module.exports = __webpack_public_path__ + "static/media/logo6.7c5b5a8c.svg";